<script>
  import { setContext } from "svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  import Grid from "$lib/components/Grid.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import ImageGridCaptions from "$lib/components/ImageGridCaptions.svelte";

  export let images = [];
  export let displayCaption = false;
  let captions = images.map(({ fields }) => fields.caption);

  function getGridConfig() {
    if (images.length >= 6) {
      return {
        maxImages: 6,
        imageColumns: { sm: 2, md: 3, lg: 3 },
        captionColumns: { sm: 1, md: 3, lg: 3 }
      };
    } else if (images.length >= 4) {
      return {
        maxImages: 4,
        imageColumns: { sm: 1, md: 2, lg: 2 },
        captionColumns: { sm: 1, md: 2, lg: 2 }
      };
    } else if (images.length === 3) {
      return {
        maxImages: 3,
        imageColumns: { sm: 1, md: 3, lg: 3 },
        captionColumns: { sm: 1, md: 3, lg: 3 }
      };
    } else {
      return {
        maxImages: 2,
        imageColumns: { sm: 1, md: 2, lg: 2 },
        captionColumns: { sm: 1, md: 2, lg: 2 }
      };
    }
  }

  const { maxImages, imageColumns, captionColumns } = getGridConfig();

  setContext("containerized", true);
</script>

<Bleed fullWidth>
  <Grid columns={imageColumns}>
    {#each images.slice(0, maxImages) as image, index}
      <div class="relative">
        <ImageComponent
          containerClass=""
          elementClass="object-cover w-full aspect-video"
          data={image}
          displayCaption={false}
        />
        {#if maxImages > 1 && displayCaption}
          <div
            class="absolute bottom-8 left-8 z-10 bg-black font-heading text-size-12 text-white px-8 py-2 rounded-full"
          >
            {index + 1}
          </div>
        {/if}
      </div>
    {/each}
  </Grid>

  {#if displayCaption}
    <ImageGridCaptions captions={captions.slice(0, maxImages)} columns={captionColumns} />
  {/if}
</Bleed>
